import { render } from "./Main.vue?vue&type=template&id=49bc728c"
const script = {}
script.render = render

export default script